import { Story, StoryPreview } from '@app/types';
import { CliqueiAcheiUser } from '@app/types/cliqueiachei';
import { adaptCliqueiAcheiClientResponseDataTo } from '@app/utils/adapters';
import axios from 'axios';
import { CliqueiAcheiClientResponseData } from './types';

const BASE_URL = 'https://www.cliqueiachei.com.br/api';

const api = axios.create({
  baseURL: BASE_URL,
});

export class APICliqueiAchei {
  static async fetchTime() {
    const { data } = await axios.get('https://api.cliqueiachei.com.br/v1/time');
    return new Date(data.now);
  }

  static async fetchClientDataById(id: string | number) {
    return await api.get<CliqueiAcheiClientResponseData>(`/telefone?id=${Math.abs(Number(id))}`);
  }

  static async fetchClientDataByUrl(url: string) {
    return await api.get<CliqueiAcheiClientResponseData>(`/telefone?url=${url}`);
  }

  static async fetchStories(cityUrl: string, start = 0, count = 1000) {
    const { data } = await api.get<FetchStoriesResponse<StoryPreview>>(
      `/stories-resume/${cityUrl}?start=${start}&count=${count}`
    );
    return data;
  }

  static async fetchClientStories(clientId: string | number, start = 0, count = 1000) {
    const { data } = await api.get<FetchStoriesResponse<Story>>(`/stories/${clientId}?start=${start}&count=${count}`);
    return data;
  }

  static async fetchClientDataAndAdaptToMenu(cliqueiAcheiId: string | number) {
    const { data: cliqueiAcheiClient } = await APICliqueiAchei.fetchClientDataById(cliqueiAcheiId);
    return adaptCliqueiAcheiClientResponseDataTo(cliqueiAcheiClient);
  }

  static async fetchUserByWhatsapp(whatsapp: string) {
    const response = await api.get<CliqueiAcheiUser>(`/app-user/${whatsapp}`);
    return response;
  }

  static async updateUserData(data: Partial<UpdateData>, deviceId: string) {
    const payload = createPayload();
    console.log('PAYLOAD: ', payload);
    await api.put(`/app-user/${deviceId}`, payload);

    function createPayload() {
      const dataAsObject = data as { [key: string]: number | string };
      const result: { [key: string]: number | string } = {};
      for (const key in data) {
        const payloadField = UpdateDataToPayloadFields[key];
        console.log(`key: ${key} -> ${payloadField}`);
        if (dataAsObject[key] !== undefined && payloadField) {
          result[payloadField] = dataAsObject[key];
        }
      }
      return result;
    }
  }

  static async createDeviceId(): Promise<string> {
    const { data } = await api.post('/app-user/new-instalation');
    return data.DeviceId;
  }

  static async createNewUser(data: Partial<UpdateData>) {
    const deviceId = await APICliqueiAchei.createDeviceId();
    await APICliqueiAchei.updateUserData(data, deviceId);
    return deviceId;
  }
}

type UpdateData = {
  name: string;
  cellphone: string;
  cityId: number;
  photoUrl: string;
  professionalStatus: string;
  dayBirth: number;
  monthBirth: number;
  yearBirth: number;
  gender: string;
};

const UpdateDataToPayloadFields: { [key: string]: string } = {
  name: 'nome',
  cellphone: 'whatsapp',
  cityId: 'cidadeId',
  professionalStatus: 'SituacaoProfissional',
  photoUrl: 'FotoUrl',
  dayBirth: 'DiaNascimento',
  monthBirth: 'MesNascimento',
  yearBirth: 'AnoNascimento',
  gender: 'Genero',
};

type FetchStoriesResponse<T> = {
  itens: T[] | null;
  total: number;
  count: number;
  start: number;
};
